import Lottie from 'lottie-react';
import LottieLoading from '@/assets/LottieLoading.json';

const NoKeywordGapData = () => {
  return (
    <div className="justify-content-center mt-3 align-items-center">
      <div
        className="mb-3 text-center"
        style={{ width: '250px', margin: 'auto' }}
      >
        <Lottie animationData={LottieLoading} />
      </div>
      <div className="mt-6 fw-medium text-center">
        برای شروع مقایسه حداقل دو دامنه معتبر روی دکمه مقایسه کلیک کنید.
      </div>
    </div>
  );
};

export default NoKeywordGapData;
